import axios from 'axios';
import { getEncryptedStorageValue, setEncryptedStorageValue } from './helper';

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // Replace with your API URL
});

// Add a request interceptor
instance.interceptors.request.use(
  (config) => {
    const accessToken = getEncryptedStorageValue('accessToken');
    if (accessToken) {
      config.headers['Authorization'] = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for handling token expiration
instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Check if error is due to an expired access token
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true; // Avoid infinite loop

      // Attempt to refresh the access token
      const refreshToken = getEncryptedStorageValue('refreshToken');
      if (refreshToken) {
        const response = await axios.post(process.env.REACT_APP_API_URL+'/login/refreshtoken', {
          refreshToken: refreshToken,
        });

        if (response.status === 200) {
          const accessToken = response.data.accessToken;
          setEncryptedStorageValue("accessToken", response.data.accessToken);
          axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
          originalRequest.headers['Authorization'] = `Bearer ${accessToken}`;
  
          return axios(originalRequest); // Retry the original request
        }
      }
    }

    return Promise.reject(error);
  }
);

export default instance;